<template>
  <div v-if="school_valid" class="experiment ma-0">
    <v-tabs
      class="elevation-2"
      background-color="#f5f5f5"
      color="red"
      slider-size="4"
    >
      <v-tab disabled>
      </v-tab>
      <v-tab :href="`#tab-booking-create`">
        {{ $t("manage.by_school.booking.tab.create") }}
      </v-tab>
      <v-tab :href="`#tab-booking-history`">
        {{ $t("manage.by_school.booking.tab.history") }}
      </v-tab>
      <v-tab-item :value="'tab-booking-create'">
        <CreateBooking />
      </v-tab-item>
      <v-tab-item :value="'tab-booking-history'">
        <BookingHistory />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>

import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);

import CreateBooking from "@/components/management/booking/CreateBookSlot.vue";
import BookingHistory from "@/components/management/booking/BookingHistory.vue";
import BookingLog from "@/components/management/booking/BookingLog.vue";

export default {
  name: "experiment",
  components: {
    CreateBooking,
    BookingHistory,
    BookingLog,
  },
  mixins: [],
  data: function () {
    return {
      menu: false,
      date1: "",
      dates: [],
      experiments: [
        {
          header: "PHYSICS",
        },
        {
          text: "APPARENT_DEPTH",
          value: "APPARENT_DEPTH",
        },
        {
          text: "EM_INDUCTION",
          value: "EM_INDUCTION",
        },
        {
          text: "EMISSION_SPECTRUM",
          value: "EMISSION_SPECTRUM",
        },
        {
          text: "INTERFERENCE",
          value: "INTERFERENCE",
        },
        {
          text: "PHOTO_ELECTRIC",
          value: "PHOTO_ELECTRIC",
        },
        {
          text: "RADIATION",
          value: "RADIATION",
        },
        {
          text: "ULTRASOUND",
          value: "ULTRASOUND",
        },
        {
          text: "NEW_INTERFERENCE",
          value: "NEW_INTERFERENCE",
        },
        {
          divider: true,
        },
        {
          header: "CHEMISTRY",
        },
        {
          text: "IDENTIFY_UNKNOWN_ANION",
          value: "IDENTIFY_UNKNOWN_ANION",
        },
        {
          text: "KINETIC_RATE",
          value: "KINETIC_RATE",
        },
        {
          text: "SPECTROPHOTOMETRY",
          value: "SPECTROPHOTOMETRY",
        },
        {
          text: "TITRATION",
          value: "TITRATION",
        },
        {
          text: "VISIBLE_SPECTRUM",
          value: "VISIBLE_SPECTRUM",
        },
        {
          divider: true,
        },
        {
          header: "BIOLOGY",
        },
        {
          text: "BACTERIA_GROWTH",
          value: "BACTERIA_GROWTH",
        },
        {
          text: "GREEN_HOUSE",
          value: "GREEN_HOUSE",
        },
        {
          text: "IODINE_TEST",
          value: "IODINE_TEST",
        },
        {
          text: "PHOTOSYNTHESIS",
          value: "PHOTOSYNTHESIS",
        },
        {
          text: "RESPIRATION",
          value: "RESPIRATION",
        },
        {
          divider: true,
        },
        {
          header: "ENGINEERING",
        },
        {
          text: "TENSILE_TEST",
          value: "TENSILE_TEST",
        },
        {
          text: "CAPACITANCE",
          value: "CAPACITANCE",
        },
      ],
      equipment_ids: [
        {
          text: "Set 0",
          value: "set_0",
        },
        {
          text: "Set 1",
          value: "set_1",
        },
        {
          text: "Set 2",
          value: "set_2",
        },
        {
          text: "Set 3",
          value: "set_3",
        },
        {
          text: "Set 4",
          value: "set_4",
        },
        {
          text: "Set 5",
          value: "set_5",
        },
        {
          text: "Set 6",
          value: "set_6",
        },
        {
          text: "Set 7",
          value: "set_7",
        },
      ],
      form: {
        start_from: "09:00",
        end_at: "18:00",
        duration: "55",
        prepare: "5",
        school: "",
        dates: [],
        experiment: "",
        equipment_id: "",
      },
      lockUnlockItem: {},
      maintenanceItem: {},
      cancelBookSlotItem: {},
      cancelBookingItem: {},
      holdCheckbox:true,
      dialog: false,
      unlockDialog: false,
      lockDialog:false,
      maintenanceDialog: false,
      unsetMaintenanceDialog:false,
      cancelBookSlotDialog: false,
      cancelBookingDialog: false,
      undoCancelBookingDialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      school_id: "",
      experiment: "",
      equipment_id: "",
      school_valid: false,
      role: null,
      drawer: true,
      mini: true,
      slot_view: false,
      breadcrumbs: "",
      booking_breadcrumbs: "",
      selected_slot: null,
      api: {
        schools: [],
        experiments: [
          {
            field: "BIOLOGY",
            experiment: "BACTERIA_GROWTH",
            experiment_name: "Bacteria Growth",
            status: "ACTIVE",
            create_at: "2022-09-06 15:55:17",
          },
        ],
        book_slots: [],
        bookings: [],
      },
      headers: [
        { text: "Ref", value: "ref" },
        { text: "School", value: "school" },
        { text: "Experiment", value: "experiment" },
        { text: "Equipment ID", value: "equipment_id" },
        { text: "Start Date", value: "start_date" },
        { text: "End Date", value: "end_date" },
        { text: "Open Time", value: "open_time" },
        { text: "Close Time", value: "close_time" },
        { text: "Duration (mins)", value: "period_time" },
        { text: "Prepare (mins)", value: "prepare_time" },
        { text: "Groups", value: "groups" },
        { text: "Status", value: "status" },
        { text: "Create by", value: "create_by" },
        { text: "Create at", value: "create_at" },
        { text: "Update at", value: "update_at" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      booking_headers: [
        { text: "Session Start", value: "start_at" },
        { text: "Session End", value: "end_at" },
        { text: "Status", value: "status" },
        { text: "Has Entered", value: "has_entered" },
        { text: "Username", value: "username" },
        { text: "Update at", value: "update_at" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  mounted: function () {
    var self = this;
    self.school_id = self.$route.params.school_id;
    self.experiment = self.$route.params.experiment;
    self.equipment_id = self.$route.params.equipment_id;
    self.form.school = self.school_id;
    self.form.experiment = self.experiment;
    self.form.equipment_id = self.equipment_id;
    self.booking_breadcrumbs = [
            { text: self.school_id },
          ];
    self.getSchoolFromSchoolList();
    self.getBookSlotsBySchool();
    self.getSchoolList();
  },
  methods: {
    getSchoolList(){
      var self = this;
      apiManagement.getSchoolList()
      .then((response) => {
          self.api.schools = response.schools;
          console.log(response)
      });
    },
    getSchoolExperiment() {
      var self = this;
      apiManagement.getSchoolExperiment(self.school_id).then((response) => {
        self.api.experiments = response.experiments;
      });
    },
    getSchoolFromSchoolList() {
      var self = this;
      apiManagement.getSchoolFromSchoolList(self.school_id).then((response) => {
        if (response.status == "success") {
          self.school_valid = true;
        } else {
          self.school_valid = false;
          alert(response.error);
        }
      });
    },
    getBookSlotsBySchool() {
      var self = this;
      apiManagement
        .getBookSlotsBySchool(self.school_id)
        .then((response) => {
          self.api.book_slots = response.book_slots;
        });
    },
    getSchoolBookings() {
      var self = this;
      apiManagement
        .getSchoolBookings(
          self.school_id,
          self.$cookies.get("experiment"),
          self.$cookies.get("equipment_id")
        )
        .then((response) => {
          self.api.book_slots = response.book_slots;
        });
    },
    viewBookings(item) {
      var self = this;
      apiManagement
        .getSchoolBookings(self.school_id, item.ref)
        .then((response) => {
          self.api.bookings = response.bookings;
          self.slot_view = true;
          self.breadcrumbs = [
            { text: item.school },
            { text: item.experiment },
            { text: item.equipment_id },
            { text: "Ref: " + item.ref },
          ];
          self.selected_slot = item;
        });
    },
    lockBookSlot(item, hold) {
      var self = this;
      apiManagement
        .lockBookSlot(self.school_id, item.ref, self.holdCheckbox)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getBookSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.school_id, item.ref)
            .then((response) => {
              self.lockUnlockItem = {};
              self.lockDialog = false;
              self.holdCheckbox = true;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.breadcrumbs = [
                { text: item.school },
                { text: item.experiment },
                { text: item.equipment_id },
                { text: "Ref: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    unlockBookSlot(item) {
      var self = this;
      apiManagement
        .unlockBookSlot(self.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getBookSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.school_id, item.ref)
            .then((response) => {
              self.lockUnlockItem = {};
              self.unlockDialog = false;
              self.holdCheckbox = true;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.breadcrumbs = [
                { text: item.school },
                { text: item.experiment },
                { text: item.equipment_id },
                { text: "Ref: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    setMaintenanceBooking(item) {
      var self = this;
      apiManagement
        .setMaintenanceBooking(self.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getBookSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.school_id, self.selected_slot.ref)
            .then((response) => {
              self.maintenanceItem = {};
              self.maintenanceDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + self.selected_slot.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    unsetMaintenanceBooking(item) {
      var self = this;
      apiManagement
        .unsetMaintenanceBooking(self.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getBookSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.school_id, self.selected_slot.ref)
            .then((response) => {
              self.maintenanceItem = {};
              self.unsetMaintenanceDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    cancelBookSlot(item) {
      var self = this;
      apiManagement
        .cancelBookSlot(self.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getBookSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.school_id, item.ref)
            .then((response) => {
              self.cancelBookSlotItem = {};
              self.cancelBookSlotDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    cancelBooking(item) {
      var self = this;
      apiManagement
        .cancelBooking(self.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getBookSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.school_id, self.selected_slot.ref)
            .then((response) => {
              self.cancelBookingItem = {};
              self.cancelBookingDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + self.selected_slot.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    undoCancelBooking(item) {
      var self = this;
      apiManagement
        .undoCancelBooking(self.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getBookSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.school_id, self.selected_slot.ref)
            .then((response) => {
              self.cancelBookingItem = {};
              self.undoCancelBookingDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + self.selected_slot.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    createBookSlots: function () {
      var self = this;     
//      if (self.isValid()) {
      apiManagement.createBookSlots(
          self.form.school,
          self.form.experiment,
          self.form.equipment_id,
          self.form.dates[0],
          self.form.dates[1],
          self.form.start_from,
          self.form.end_at,
          self.form.duration,
          self.form.prepare
        )
        .then((response) => {
          if (response.status == "success") {
            alert("success");
//            alert("Assigned " + response.count + " slots successfully");
          } else {
            alert(response.message);
          }
        });
//      }
    },
    isValid: function () {
      var self = this;
      if (self.dates[0] == null) {
        alert("missing Start date");
        return false;
      }
      if (self.dates[1] == null) {
        alert("missing End date");
        return false;
      }
      if (self.dates[0] > self.dates[1]) {
        alert("End date should be larger than Start date");
        return false;
      }
      if (self.form.equipment_id == null) {
        alert("missing Experiment");
        return false;
      }
      if (self.form.equipment_id == null) {
        alert("missing Equipment ID");
        return false;
      }
      return true;
    },
    back() {
      var self = this;
      self.$router.push("/school/experiment_list/" + self.school_id);
    },
    openLockDialog(item){
      var self = this;
      self.lockDialog = true;
      self.lockUnlockItem = item;
      self.holdCheckbox = true;
    },
    openUnlockDialog(item){
      var self = this;
      self.unlockDialog = true;
      self.lockUnlockItem = item;
    },
    openMaintenanceDialog(item){
      var self = this;
      self.maintenanceDialog = true;
      self.maintenanceItem = item;
    },
    openUnsetMaintenanceDialog(item){
      var self = this;
      self.unsetMaintenanceDialog = true;
      self.maintenanceItem = item;
    },
    openCancelBookSlotDialog(item){
      var self = this;
      self.cancelBookSlotDialog = true;
      self.cancelBookSlotItem = item;
    },
    openCancelBookingDialog(item){
      var self = this;
      self.cancelBookingDialog = true;
      self.cancelBookingItem = item;
    },
    openUndoCancelBookingDialog(item){
      var self = this;
      self.undoCancelBookingDialog = true;
      self.cancelBookingItem = item;
    },
  },
  computed: {
    dateRangeText() {
      return this.form.dates.join(" ~ ");
    },
    calculated_no_of_slots() {
      var self = this;
      return 1440 / (parseInt(self.form.duration) + parseInt(self.form.rest));
    },
  },
  destroyed() {
    clearInterval(this.kick_inte);
    self.$cookies.remove("experiment");
    self.$cookies.remove("equipment_id");
    console.log("destroyed");
  },
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>